export class Document {
    public checked: boolean = false;
    public id: number = null;
    public name: string = '';
    public building: any = {};
    public buildings: Array<any> = [];
    public corporationNumbers: Array<any> = [];
    public createdBy: any = {};
    public createdAt: Date;
    public type: string = '';
    public documentsPermissions: Array<string> = [];
    public path: string = '';
    public parent: number = null;
    public shared: number = null;
    public isPublic: boolean = false;
    public children: Array<Document> = [];
    public size: number = null;
    public isOpen: boolean = false;
    public nestedLevel: number = 1;
    public isCanEdit: boolean = false;
    public isCanDelete: boolean = false;
    public userGroups: {name: string, bdId: number}[] = [];

    constructor(document) {
        this.id = document.id;
        this.name = document.name;
        this.building = document.building;
        this.createdBy = document.createdBy;
        this.createdAt = new Date(document.createdAt);
        this.type = document.type;
        this.documentsPermissions = document.documentsPermissions;
        this.path = document.path;
        this.parent = document.parent;
        this.shared = document.shared;
        this.isPublic = document.isPublic;
        this.children = document.children || [];
        this.size = document.size;
        this.userGroups = document.userGroups || [];
        this.isOpen = false;
        this.nestedLevel = 1;
    }

    get isImage() {
        return (/\.(gif|jpg|jpeg|tiff|png)$/i).test(this.path);
    }

    get idDirectory() {
        return this.type === 'directory';
    }

    show(): void {
        if (this.type === 'file') {
            const _src = `https://docs.google.com/viewer?url=${this.path}&embedded=true`;
            window.open(_src);
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/document-data.types.ts